class MasonryGrid {
	constructor(selector) {
		this.grid = document.querySelector(selector);
		if (!this.grid) return;

		this.items = Array.from(this.grid.children);
		this.columnCount = 1;
		this.breakpoints = {
			tablet: 768
		};
		
		this.init();
	}

	init() {
		this.updateLayout();
		this.bindEvents();
	}

	bindEvents() {
		window.addEventListener('resize', () => this.updateLayout());
		window.addEventListener('load', () => this.updateLayout());
	}

	updateLayout() {
		this.setResponsiveSettings();
		this.layout();
	}

	setResponsiveSettings() {
		const width = window.innerWidth;
		
		this.columnCount = width >= this.breakpoints.tablet ? 2 : 1;
		this.gap = this.getGapFromCSS();
	}

	getGapFromCSS() {
		const gapValue = getComputedStyle(this.grid).getPropertyValue('--masonry-gap').trim();
		return parseInt(gapValue) || 24;
	}

	resetStyles() {
		this.grid.classList.remove('masonry-active');
		this.grid.style.removeProperty('--masonry-height');
		
		this.items.forEach(item => {
			item.classList.remove('masonry-item');
			item.style.removeProperty('--masonry-width');
			item.style.removeProperty('--masonry-left');
			item.style.removeProperty('--masonry-top');
		});
	}

	layout() {
		if (this.columnCount === 1) {
			this.resetStyles();
			return;
		}

		this.positionItems();
	}

	positionItems() {
		const columnHeights = new Array(this.columnCount).fill(0);
		const columnWidth = this.calculateColumnWidth();

		this.grid.classList.add('masonry-active');

		this.items.forEach(item => {
			const shortestColumnIndex = this.getShortestColumnIndex(columnHeights);
			
			this.positionItem(item, shortestColumnIndex, columnWidth, columnHeights[shortestColumnIndex]);
			
			columnHeights[shortestColumnIndex] += item.offsetHeight + this.gap;
		});

		this.setGridHeight(columnHeights);
	}

	calculateColumnWidth() {
		const totalGapWidth = this.gap * (this.columnCount - 1);
		return (this.grid.offsetWidth - totalGapWidth) / this.columnCount;
	}

	getShortestColumnIndex(columnHeights) {
		return columnHeights.indexOf(Math.min(...columnHeights));
	}

	positionItem(item, columnIndex, columnWidth, topPosition) {
		item.classList.add('masonry-item');
		item.style.setProperty('--masonry-width', `${columnWidth}px`);
		item.style.setProperty('--masonry-left', `${columnIndex * (columnWidth + this.gap)}px`);
		item.style.setProperty('--masonry-top', `${topPosition}px`);
	}

	setGridHeight(columnHeights) {
		const maxHeight = Math.max(...columnHeights) - this.gap;
		this.grid.style.setProperty('--masonry-height', `${maxHeight}px`);
	}
}

export default MasonryGrid;
